import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { ComponentPageTitle } from 'src/app/page-title/page-title.component';
import { GatewayService } from 'src/app/gateway.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { MatPaginator, MatTableDataSource, MatSnackBar, MatDialog, PageEvent } from '@angular/material';
import { FormGroup, FormControl } from '@angular/forms';
import { DescargarLotesComponent } from '../descargar-lotes/descargar-lotes.component';
import { CitaTentativaHelperService } from 'src/app/services/cita-tentativa-helper.service';
import { Chart } from 'chart.js';

const STATE_COLORS = {
  'Candidato a Contactar':     { bg: '#DBEAFE', text: '#1E40AF', border: '#93C5FD' },
  'Primer Contacto Enviado':   { bg: '#FEF3C7', text: '#92400E', border: '#FCD34D' },
  'Segundo Contacto Enviado':  { bg: '#FFEDD5', text: '#9A3412', border: '#FDBA74' },
  'Tercer Contacto Enviado':   { bg: '#FEE2E2', text: '#991B1B', border: '#FCA5A5' },
  'Cliente Acepta Visita':     { bg: '#D1FAE5', text: '#065F46', border: '#6EE7B7' },
  'Cliente Agenda Visita':     { bg: '#E0E7FF', text: '#3730A3', border: '#A5B4FC' },
  'Cliente No Acepta Visita':  { bg: '#FCE7F3', text: '#9D174D', border: '#F9A8D4' },
  'Cerrado':                   { bg: '#F1F5F9', text: '#334155', border: '#94A3B8' },
  'Sin estado':                { bg: '#F1F5F9', text: '#475569', border: '#CBD5E1' }
};

const CHART_COLORS = ['#3B82F6', '#F59E0B', '#F97316', '#EF4444', '#10B981', '#6366F1', '#EC4899', '#64748B'];

@Component({
  selector: 'app-bitacora-proactivos',
  templateUrl: './bitacora-proactivos.component.html',
  styleUrls: ['./bitacora-proactivos.component.scss']
})
export class BitacoraProactivosComponent implements OnInit {

  pageSize = 10;
  FILTER: string = null;

  estadosEntrada = [
    { value: null, label: 'Todos' },
    { value: 1, label: 'Candidato a Contactar' },
    { value: 2, label: 'Primer Contacto Enviado' },
    { value: 3, label: 'Segundo Contacto Enviado' },
    { value: 4, label: 'Tercer Contacto Enviado' },
    { value: 5, label: 'Cuarto Contacto Telefónicamente' },
    { value: 6, label: 'Cliente Agenda Visita' },
    { value: 7, label: 'Técnico Asignado Visita en Curso' },
    { value: 8, label: 'Cerrado' },
    { value: 9, label: 'Cliente No Acepta Visita' },
    { value: 10, label: 'Candidato en Garantía' },
    { value: 11, label: 'Cliente Acepta Visita' },
    { value: 12, label: 'Cliente no Responde' },
    { value: 13, label: 'Intento de Contacto Manual 1' },
    { value: 14, label: 'Intento de Contacto Manual 2' },
    { value: 15, label: 'Intento de Contacto Manual 3' },
    { value: 16, label: 'Cliente No Contactado' },
    { value: 17, label: 'Cliente Solicita Rellamar' }
  ];

  grupoValBitacora = new FormGroup({
    filtro: new FormControl(''),
    telefono: new FormControl(''),
    cuenta: new FormControl(''),
    falla: new FormControl(''),
    estado_entrada: new FormControl(null)
  });

  reporteColumns: string[] = [];
  dataSource = new MatTableDataSource<any>([]);
  resultsLength: number = 0;

  @ViewChild('bitacoraPaginator') bitacoraPaginator: MatPaginator;
  @ViewChild('bitacoraTable') bitacoraTable: any;

  // Dashboard properties
  @ViewChild('dailyChart') dailyChartRef: ElementRef;
  @ViewChild('stackedChart') stackedChartRef: ElementRef;
  @ViewChild('donutChart') donutChartRef: ElementRef;
  @ViewChild('queueChart') queueChartRef: ElementRef;
  @ViewChild('timesChart') timesChartRef: ElementRef;

  dashboardLoaded = false;
  dashboardLoading = false;
  totales: any = {};
  funnelData: any[] = [];
  duplicados: any[] = [];
  maxDup = 1;
  queueOk = 0;
  queueErr = 0;
  queuePend = 0;
  queueOkPct = '0';

  flujoData: any[] = [];
  flujoFiltered: any[] = [];
  flujoSearch = '';
  flujoStateCols: string[] = [];

  private charts: Chart[] = [];

  constructor(
    public pageTitle: ComponentPageTitle,
    private gateway: GatewayService,
    private spinner: NgxSpinnerService,
    private localSave: LocalSaveService,
    private snackbar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
    private tentativaHelper: CitaTentativaHelperService
  ) {}

  ngOnInit() {
    this.pageTitle.title = 'Bitácora de Proactivos';
    this.getBitacora(0);
    this.loadDashboard();
  }

  // =====================================================================
  // DASHBOARD
  // =====================================================================

  getStateColor(estado: string): any {
    return STATE_COLORS[estado] || STATE_COLORS['Sin estado'];
  }

  loadDashboard() {
    this.dashboardLoading = true;

    Promise.all([
      this.gateway.get('metricasContactoIsoft', {}),
      this.gateway.get('metricasContactoIsoftTiempos', {}),
      this.gateway.get('metricasContactoIsoftFlujo', { limit: 200, offset: 0 })
    ]).then(([metricas, tiempos, flujo]: any[]) => {
      this.totales = metricas.totales || {};
      this.duplicados = metricas.duplicados || [];
      this.maxDup = this.duplicados.length > 0 ? this.duplicados[0].veces : 1;

      // Queue totals
      const qd = metricas.queueDiaria || [];
      this.queueOk = qd.reduce((s, r) => s + (r.ok || 0), 0);
      this.queueErr = qd.reduce((s, r) => s + (r.errores || 0), 0);
      this.queuePend = qd.reduce((s, r) => s + (r.pendientes || 0), 0);
      const totalQ = this.totales.total_queue || 1;
      this.queueOkPct = (this.queueOk / totalQ * 100).toFixed(1);

      // Funnel data
      const funnelOrder = ['Candidato a Contactar', 'Primer Contacto Enviado', 'Segundo Contacto Enviado',
        'Tercer Contacto Enviado', 'Cliente Acepta Visita', 'Cliente Agenda Visita', 'Cliente No Acepta Visita'];
      const funnelMap = {};
      (metricas.funnel || []).forEach(f => { funnelMap[f.estado] = f.total; });
      // Also add contacts that entered as Candidato (from estadoActual since all start there)
      if (!funnelMap['Candidato a Contactar']) {
        funnelMap['Candidato a Contactar'] = this.totales.total_contactos || 0;
      }
      const maxFunnel = Math.max(...funnelOrder.map(s => funnelMap[s] || 0), 1);
      this.funnelData = funnelOrder.map(s => ({
        estado: s,
        total: funnelMap[s] || 0,
        pct: ((funnelMap[s] || 0) / maxFunnel * 100).toFixed(0)
      }));

      // Flujo
      this.flujoData = (flujo.flujo || []);
      this.flujoFiltered = this.flujoData;
      const maxStates = this.flujoData.reduce((m, r) => Math.max(m, (r.estados || []).length), 0);
      this.flujoStateCols = Array.from({ length: maxStates }, (_, i) => 'e' + i);

      this.dashboardLoading = false;
      this.dashboardLoaded = true;
      this.cdr.detectChanges();

      // Render charts after view updates
      setTimeout(() => {
        this.renderDailyChart(metricas.entradasDiarias || []);
        this.renderStackedChart(metricas.cambiosEstadoDiarios || [], metricas.entradasDiarias || []);
        this.renderDonutChart(metricas.estadoActual || []);
        this.renderQueueChart(metricas.queueDiaria || []);
        this.renderTimesChart((tiempos.tiempos || []));
      }, 100);
    }).catch((err) => {
      console.error('Error cargando dashboard:', err);
      this.dashboardLoading = false;
      this.snackbar.open('Error al cargar métricas del dashboard.', 'Cerrar', { duration: 3000 });
    });
  }

  filterFlujo() {
    const q = (this.flujoSearch || '').toLowerCase();
    if (!q) {
      this.flujoFiltered = this.flujoData;
    } else {
      this.flujoFiltered = this.flujoData.filter(r =>
        (r.account_id || '').toLowerCase().includes(q) || String(r.id).includes(q)
      );
    }
  }

  private renderDailyChart(data: any[]) {
    if (!this.dailyChartRef) return;
    const ctx = this.dailyChartRef.nativeElement;
    this.charts.push(new Chart(ctx, {
      type: 'bar',
      data: {
        labels: data.map(d => (d.fecha || '').substring(5)),
        datasets: [{
          label: 'Entradas',
          data: data.map(d => d.total),
          backgroundColor: '#3B82F6',
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        scales: {
          yAxes: [{ ticks: { beginAtZero: true }, gridLines: { color: '#F1F5F9' } }],
          xAxes: [{ gridLines: { display: false }, ticks: { maxRotation: 45, fontSize: 10 } }]
        }
      }
    }));
  }

  private renderStackedChart(cambios: any[], entradas: any[]) {
    if (!this.stackedChartRef) return;
    const ctx = this.stackedChartRef.nativeElement;

    // Group by day and state from entradas (estado actual distribution per entry day)
    // We'll use cambiosEstadoDiarios to show state activity per day
    const days = Array.from(new Set(cambios.map(c => c.fecha))).sort();
    const states = Array.from(new Set(cambios.map(c => c.estado)));
    const datasets = states.map((state, i) => ({
      label: state,
      data: days.map(day => {
        const match = cambios.find(c => c.fecha === day && c.estado === state);
        return match ? match.total : 0;
      }),
      backgroundColor: (STATE_COLORS[state] || STATE_COLORS['Sin estado']).border,
    }));

    this.charts.push(new Chart(ctx, {
      type: 'bar',
      data: { labels: days.map(d => (d || '').substring(5)), datasets },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { position: 'bottom', labels: { boxWidth: 12, fontSize: 10 } },
        scales: {
          xAxes: [{ stacked: true, gridLines: { display: false }, ticks: { maxRotation: 45, fontSize: 9 } }],
          yAxes: [{ stacked: true, gridLines: { color: '#F1F5F9' } }]
        }
      }
    }));
  }

  private renderDonutChart(data: any[]) {
    if (!this.donutChartRef) return;
    const ctx = this.donutChartRef.nativeElement;
    this.charts.push(new Chart(ctx, {
      type: 'doughnut',
      data: {
        labels: data.map(d => d.estado),
        datasets: [{
          data: data.map(d => d.total),
          backgroundColor: data.map(d => (STATE_COLORS[d.estado] || STATE_COLORS['Sin estado']).border),
          borderWidth: 2,
          borderColor: '#fff'
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 55,
        legend: { position: 'bottom', labels: { boxWidth: 10, fontSize: 10, padding: 8 } }
      }
    }));
  }

  private renderQueueChart(data: any[]) {
    if (!this.queueChartRef) return;
    const ctx = this.queueChartRef.nativeElement;
    this.charts.push(new Chart(ctx, {
      type: 'bar',
      data: {
        labels: data.map(d => (d.fecha || '').substring(5)),
        datasets: [
          { label: 'Enviado OK', data: data.map(d => d.ok || 0), backgroundColor: '#10B981' },
          { label: 'Pendiente', data: data.map(d => d.pendientes || 0), backgroundColor: '#F59E0B' },
          { label: 'Error', data: data.map(d => d.errores || 0), backgroundColor: '#EF4444' }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { position: 'bottom', labels: { boxWidth: 10, fontSize: 10 } },
        scales: {
          xAxes: [{ stacked: true, gridLines: { display: false }, ticks: { maxRotation: 45, fontSize: 9 } }],
          yAxes: [{ stacked: true, gridLines: { color: '#F1F5F9' } }]
        }
      }
    }));
  }

  private renderTimesChart(data: any[]) {
    if (!this.timesChartRef) return;
    const ctx = this.timesChartRef.nativeElement;
    const filtered = data.filter(t => t.horas_promedio > 0);
    const labels = filtered.map(t =>
      (t.estado_anterior + ' → ' + t.estado_nuevo)
        .replace(/Contacto Enviado/g, 'CE')
        .replace('Candidato a Contactar', 'CaC')
        .replace('Cliente ', '')
    );
    this.charts.push(new Chart(ctx, {
      type: 'horizontalBar',
      data: {
        labels: labels,
        datasets: [{
          label: 'Horas promedio',
          data: filtered.map(t => t.horas_promedio),
          backgroundColor: filtered.map((_, i) => CHART_COLORS[i % CHART_COLORS.length]),
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        scales: {
          xAxes: [{ gridLines: { color: '#F1F5F9' }, scaleLabel: { display: true, labelString: 'Horas', fontSize: 10 } }],
          yAxes: [{ gridLines: { display: false }, ticks: { fontSize: 9 } }]
        }
      }
    }));
  }

  // =====================================================================
  // BITACORA TABLE (existing)
  // =====================================================================

  trackByColumn(index: number, column: string): string {
    return column;
  }

  getDisplayedColumns(): string[] {
    return ['TELEFONO', ...this.reporteColumns];
  }

  onClickChipTentativa(row: any): void {
    const idcliente = row.idcliente || row.IDCLIENTE || row.IdCliente;
    const telefono = row.TELEFONO || row.Telefono || row.telefono || row.acct_contact_phone1;
    const idcampana = row.idcampana || 199;
    const idContactoIsoft = row.id || row.ID;
    const cuenta = row.Cuenta || row.cuenta || row.CUENTA || row.account_id;
    this.tentativaHelper.openTentativaParaCliente(idcliente, telefono, idcampana, true, idContactoIsoft, cuenta);
  }

  tieneTentativaVisible(row: any): boolean {
    if (!row) return false;
    return Number(row.tiene_tentativa) === 1 || Number(row.id_estado_de_entrada) === 11;
  }

  getChipTentativaStyle(row: any): { cssClass: string, tooltip: string } {
    if (Number(row.id_estado_de_entrada) === 11) {
      return { cssClass: 'chip-tentativa-activa', tooltip: 'Cita tentativa activa - Click para ver detalles' };
    }
    return { cssClass: 'chip-tentativa-referencia', tooltip: 'Cliente tiene cita tentativa pendiente - Click para ver' };
  }

  formatColumnName(column: string): string {
    return column.replace(/_/g, ' ').toUpperCase();
  }

  public isDateColumn(column: string): boolean {
    const dateKeywords = ['fecha', 'date', 'inicio', 'fin', 'final', 'cleared'];
    const excludeKeywords = ['notification_count', 'count', 'time', 'tiempo'];
    const columnLower = column.toLowerCase();

    if (excludeKeywords.some(keyword => columnLower.includes(keyword))) {
      return false;
    }

    return dateKeywords.some(keyword => columnLower.includes(keyword));
  }

  public isTimeOnlyValue(value: any): boolean {
    if (!value) return false;
    if (typeof value === 'string') {
      const timeOnlyPattern = /^\d{1,2}:\d{2}(:\d{2})?$/;
      return timeOnlyPattern.test(value.trim());
    }
    return false;
  }

  public cambioElementosBitacora(event?: PageEvent) {
    this.getBitacora(event.pageIndex);
  }

  generarBitacora() {
    if (this.bitacoraPaginator) {
      this.bitacoraPaginator.firstPage();
    }
    this.getBitacora(0);
  }

  getBitacora(page) {
    if (page == 0) {
      if (this.bitacoraPaginator) {
        this.bitacoraPaginator.firstPage();
      }
    }

    let estadoEntradaSeleccionado = this.grupoValBitacora.controls.estado_entrada.value;
    let estadoEntradaNumero = estadoEntradaSeleccionado
      ? (Array.isArray(estadoEntradaSeleccionado) ? estadoEntradaSeleccionado[0] : estadoEntradaSeleccionado)
      : null;

    let params: any = {
      page: page,
      pageSize: this.pageSize,
      sortBy: "Cuenta",
      sortOrder: "DESC"
    };

    if (estadoEntradaNumero !== null) {
      params.estado_entrada = estadoEntradaNumero;
    }

    let telefono = this.grupoValBitacora.controls.telefono.value;
    let cuenta = this.grupoValBitacora.controls.cuenta.value;
    let falla = this.grupoValBitacora.controls.falla.value;
    let nombre = this.FILTER || this.grupoValBitacora.controls.filtro.value;

    if (telefono) params.telefono = telefono;
    if (cuenta) params.cuenta = cuenta;
    if (falla) params.falla = falla;
    if (nombre) params.nombre = nombre;

    this.spinner.show();

    this.gateway.get('listarBitacoraProactivos', params).then((result: any) => {
      let registros = result.rows || [];

      const resolveTotal = () => {
        if (result.total !== undefined) {
          this.resultsLength = result.total;
          this.spinner.hide();
        } else {
          this.gateway.get('contarBitacoraProactivos', params).then((countResult: any) => {
            this.resultsLength = countResult.rows[0].total;
            this.spinner.hide();
          }).catch(() => {
            this.spinner.hide();
          });
        }
      };

      if (!registros || registros.length === 0) {
        this.dataSource = new MatTableDataSource([]);
        this.resultsLength = 0;
        resolveTotal();
        return;
      }

      if (this.reporteColumns.length === 0 && registros.length > 0) {
        let columnas = Object.keys(registros[0]);
        columnas = columnas.filter(key =>
          !['TELEFONO', 'Telefono', 'telefono', 'acct_contact_phone1', 'ACCT_CONTACT_PHONE1', 'phone', 'PHONE', 'phone1', 'PHONE1', 'idcliente', 'IDCLIENTE', 'IdCliente'].includes(key)
        );
        this.reporteColumns = [...columnas];
      }

      this.dataSource = new MatTableDataSource(registros);
      this.cdr.detectChanges();

      setTimeout(() => {
        if (this.bitacoraTable) {
          this.bitacoraTable.updateStickyColumnStyles();
        }
        this.cdr.detectChanges();
      }, 100);

      resolveTotal();
    }).catch((e) => {
      this.spinner.hide();
      this.snackbar.open('Error al cargar la Bitácora de Proactivos.', 'Cerrar', { duration: 3000 });
    });
  }

  keyDownFunction(event) {
    if (event.keyCode == 13) {
      this.applyBitacoraFilter();
    }
  }

  applyBitacoraFilter() {
    this.FILTER = this.grupoValBitacora.controls.filtro.value || '';
    if (this.bitacoraPaginator) {
      this.bitacoraPaginator.firstPage();
    }
    this.getBitacora(0);
  }

  descargar() {
    let params: any = { sortBy: 'Cuenta', sortOrder: 'DESC' };
    const estadoVal = this.grupoValBitacora.controls.estado_entrada.value;
    if (estadoVal !== null) params.estado_entrada = estadoVal;
    const telefono = this.grupoValBitacora.controls.telefono.value;
    const cuenta = this.grupoValBitacora.controls.cuenta.value;
    const falla = this.grupoValBitacora.controls.falla.value;
    const nombre = this.FILTER || this.grupoValBitacora.controls.filtro.value;
    if (telefono) params.telefono = telefono;
    if (cuenta) params.cuenta = cuenta;
    if (falla) params.falla = falla;
    if (nombre) params.nombre = nombre;

    const ahora = new Date();
    const ts = ahora.getFullYear() + ('0' + (ahora.getMonth() + 1)).slice(-2) + ('0' + ahora.getDate()).slice(-2) + '_' + ('0' + ahora.getHours()).slice(-2) + ('0' + ahora.getMinutes()).slice(-2);

    this.dialog.open(DescargarLotesComponent, {
      disableClose: true,
      width: '700px',
      data: {
        cantPorPagina: 1000,
        nombreServicioCantRegistros: 'contarBitacoraProactivos',
        nombreServicioRegistros: 'listarBitacoraProactivosDescarga',
        nombreArchivo: `bitacora_proactivos_${ts}.xlsx`,
        params: params
      }
    });
  }

  limpiarFiltrosBitacora() {
    this.grupoValBitacora.reset({ filtro: '', telefono: '', cuenta: '', falla: '', estado_entrada: null });
    this.FILTER = null;
    if (this.bitacoraPaginator) {
      this.bitacoraPaginator.firstPage();
    }
    this.getBitacora(0);
  }
}
